import { useRecoilState, useResetRecoilState } from 'recoil';

import {
  activeBalloonOptionState,
  financeCalculationState,
  financeFilterState,
  selectedFinanceFilterStateSelector,
} from '@/states/filters/finance.state';

export function useFinanceFilter() {
  const [financeFilter, setFinanceFilter] = useRecoilState(financeFilterState);
  const [financeCalculation, setFinanceCalculation] = useRecoilState(
    financeCalculationState
  );
  const [selectedFinanceFilter, setSelectedFinanceFilter] = useRecoilState(
    selectedFinanceFilterStateSelector
  );
  const [activeBalloonOption, setActiveBalloonOption] = useRecoilState(
    activeBalloonOptionState
  );

  const resetFinanceState = useResetRecoilState(financeFilterState);

  return {
    financeFilter,
    setFinanceFilter,
    financeCalculation,
    setFinanceCalculation,
    selectedFinanceFilter,
    setSelectedFinanceFilter,
    resetFinanceState,
    activeBalloonOption,
    setActiveBalloonOption,
  };
}
